// Init jQuery
 jQuery("input[name='your-telephone']")
        .mask("(99) 9999-9999?9")
        .focusout(function (event) {  
            var target, phone, element;  
            target = (event.currentTarget) ? event.currentTarget : event.srcElement;  
            phone = target.value.replace(/\D/g, '');
            element = $(target);  
            element.unmask();  
            if(phone.length > 10) {  
                element.mask("(99) 99999-999?9");  
            } else {  
                element.mask("(99) 9999-9999?9");  
            }  
        });
jQuery(document).ready(function() {
    menuFixed();
    MenuMob();
    //SendContato();
    jQuery(".fancybox").fancybox();
    jQuery('.header__slide__each').imgLiquid();
    jQuery("#servicos__carousel").owlCarousel({
        pagination: false,
        itemsCustom: [
            [0, 1],
            [495, 1],
            [720, 2],
            [1200, 3],
        ],
    });
    $(".left__carousel").click(function() {
        jQuery("#servicos__carousel").trigger('owl.prev');
        
    })
    $(".right__carousel").click(function() {
       jQuery("#servicos__carousel").trigger('owl.next');
    })
    jQuery(".galeria__carousel").owlCarousel({
        pagination: false,
        itemsCustom: [
            [0, 1],
            [768, 3],
            [1024, 4],
        ],
    });
    $('#menu').onePageNav({
        currentClass: 'current',
        changeHash: false,
        scrollSpeed: 750,
        scrollThreshold: 0.5,
        filter: '',
        easing: 'swing',
        begin: function() {
            //I get fired when the animation is starting
        },
        end: function() {
            //I get fired when the animation is ending
        },
        scrollChange: function($currentListItem) {
            //I get fired when you enter a section and I pass the list item of the section
        }
    });

});
/*  Scroll Fixed Menu */
var menuFixed = function() {

    var mq = window.matchMedia( "(min-width: 767px)" );

    if (mq.matches) {
        var a = $(".header"),
        e = 78;
        $(document).bind("scroll", function() {
        var doc = $(document).scrollTop();

        if (doc > e) {
            $(".header").addClass("animated fadeInDown header__fixed")
        } else if (doc < e) {
            $(".header").removeClass("fadeInDown header__fixed").addClass("fadeInDown");
        };
    });
    }
  
}

var MenuMob = function(){
    jQuery(".header__btnMenu").on('click', function(){
        jQuery(".header__menu").toggleClass("active_menu");
    });
}

SendContato = function() {
    $(".message").length >= 1 && $(".message").hide(), $(".contato__btn").on("click", function() {
        if (!ValidadeFrorm("#Contato")) return !1;
        var a = $("#nomeContato").val(),
            e = $("#emailContato").val(),
            i = $("#telContato").val(),
            t = $("#msgContato").val(),
            r = "1";
        $("#Contato").fadeOut("fast").delay(1000).before("<section id='loaderAjax'><span>Enviando</span></section"),
        $.post("/wp-content/themes/renatagaia/SendForm.php", {
            nome: a,
            email: e,
            phone: i,
            msg: t,
            form: r
        }, function(a) {
            a.status ? $("#Contato").fadeOut({
                done: function() {

                }
            }) : $(".message.Error").fadeIn("fast")
        }, "json").done(function() {
            $("#loaderAjax").hide()
        })
    })
}
ValidadeFrorm = function(a) {
    var e = !0;
    return $(a).find(".required").each(function() {
        "" == this.value ? ($(this).addClass("erroLogin"), $(this).focus(function() {
            $(this).removeClass("erroLogin")
        }), e = !1) : "email" == $(this).attr("data-validate") && (ValidadeMail(this.value) || ($(this).addClass("erroLogin"), $(this).focus(function() {
            $(this).removeClass("erroLogin")
        }), e = !1))
    }), e
}
ValidadeMail = function(a) {
    var e = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return e.test(a)
}
